import React from 'react';

import type { AddressList } from '@swf/components/AddressResults/AddressResults';
import { SearchDataType } from '@swf/components/AddressResults/AddressResults';
import ClusterResult from '@swf/components/AddressResults/ClusterResult/ClusterResult';
import SingleResult from '@swf/components/AddressResults/SingleResult/SingleResult';

interface Props {
  searchResults: AddressList[];
  clusterFind: (payload: { container: string }) => void;
  getAddressDetails: (payload: { id: string }) => void;
}

const SearchResult: React.FC<Props> = ({ searchResults, clusterFind, getAddressDetails }) => (
  <>
    {searchResults.map((item) =>
      item.type === SearchDataType.Address ? (
        <div key={item.id} onClick={() => getAddressDetails({ id: item.id })}>
          <SingleResult {...item} />
        </div>
      ) : (
        <div key={item.id} onClick={() => clusterFind({ container: item.id })}>
          <ClusterResult {...item} />
        </div>
      )
    )}
  </>
);

export default SearchResult;
